import { simpleItemModel } from './simpleItem';

export const alternativeProducts = alternativeList =>
  alternativeList?.length > 0
    ? alternativeList.map(item => simpleItemModel(item))
    : [];
